import React from 'react';
import ChatWidget from 'components/chat/ChatWidget/ChatWidget';

const ChatPage: React.FC = () => {
	return (
		<div>
			<ChatWidget
				closeWidget={() => {}}
				isHomeScreen={false}
				setIsHomeScreen={() => {}}
				hideHeader
			/>
		</div>
	);
};


export default ChatPage;
